module.exports = __webpack_public_path__ + "img/OVCA_B.3faff2eb.png";